var amt_admin = require('amt_admin').default;
var app = require('angular').module('ww2_analytics.runner_battler', [amt_admin]);

app.service('runner_battler_api', ['jsonrpc', function (jsonrpc) {
  var service = jsonrpc.newService('runner_battler');
  this.get_total_install_count = service.createMethod('get_total_install_count');
  this.retention_by_mission_table = service.createMethod('retention_by_mission_table');
  this.retention_classic_table = service.createMethod('retention_classic_table');
}]);

app.config(['$stateProvider', function($stateProvider) {
  $stateProvider
    .state('amt.ww2.runner_battler', {
      url: '/runner_battler',
      abstract: true,
      template: '<div class="row" ui-view></div>',
      data: {
        priority: 100,
        title: 'Runner Battler',
        role: 'runner_battler'
      },
      menu: {
        glyphicon: 'screenshot',
        childs: [
          {state: 'amt.ww2.runner_battler.mission_win_rate', glyphicon: 'screenshot'},
          {state: 'amt.ww2.runner_battler.retention_by_mission', glyphicon: 'screenshot'},
          {state: 'amt.ww2.runner_battler.retention_classic', glyphicon: 'screenshot'},
          {state: 'amt.ww2.runner_battler.retention_churn', glyphicon: 'screenshot'},
          {state: 'amt.ww2.runner_battler.retention_short', glyphicon: 'screenshot'},
          {state: 'amt.ww2.runner_battler.sessions', glyphicon: 'screenshot'},
        ],
      },
    })
    .state('amt.ww2.runner_battler.mission_win_rate', require('./mission_win_rate').default)
    .state('amt.ww2.runner_battler.retention_by_mission', require('./retention_by_mission').default)
    .state('amt.ww2.runner_battler.retention_classic', require('./retention_classic').default)
    .state('amt.ww2.runner_battler.retention_churn', require('./retention_churn').default)
    .state('amt.ww2.runner_battler.retention_short', require('./retention_short').default)
    .state('amt.ww2.runner_battler.sessions', require('./sessions').default)
}]);

export default app.name;
